import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {filter} from 'rxjs/operators';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  subscription: Subscription;

  temporaryId: string;

  constructor(
    private router: Router
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        (<any>window).ga('set', 'page', event.urlAfterRedirects);
        (<any>window).ga('send', 'pageview');
      }
    });
  }

  ngOnInit(): void {
    this.checkId();

    this.subscription = this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe(() => window.scrollTo(0, 0));
  }


  checkId() {
    const tempId = localStorage.getItem('tId');
    if (!tempId) {
      this.temporaryId = this.generateId(30);
      localStorage.setItem('tId', this.temporaryId);
    }
  }

  generateId(len) {
    const arr = new Uint8Array((len || 40) / 2);
    window.crypto.getRandomValues(arr);
    return Array.from(arr, this.dec2hex).join('');
  }

  dec2hex(dec) {
    return ('0' + dec.toString(16)).substr(-2);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
